import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { CKEditorModule } from 'ng2-ckeditor';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CKEditorModule } from 'ckeditor4-angular';
import * as $ from 'jquery';

import { RouterModule } from '@angular/router';
import { routes } from './app-routing.module';
import { AppComponent } from './app.component';

//[JWT-AUTH] -------------------------------------------
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorInterceptor, JwtInterceptor } from './core/_helpers';

//npm custom-package -------------------------------
import { ToastrModule } from 'ngx-toastr';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar'; 			//[Loading-Bar]

//Layout ------------------------------------------
//import { SharedModule } from './shared/shared.module';
import { AuthModule } from './auth/auth.module';
import { BuyLevelComponent } from './buy-level/buy-level.component';


@NgModule({
  declarations: [
    AppComponent,
    BuyLevelComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SlimLoadingBarModule,
    HttpClientModule,
    FormsModule,
    CKEditorModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      enableHtml: true
    }),
    AuthModule,
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [BrowserModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
